// import dayjs from "dayjs";

// // ---------------------------------------------------------------------------
// // GOLDEN RULE: the Form.Item `name` used in every *LandForm.js component must
// // be IDENTICAL to the key the API returns inside section1..sectionN arrays
// // (parentheses, slashes, everything). That way this file never needs to know
// // about individual field names, and GET -> populate -> edit -> PATCH is a
// // clean round trip. Do NOT reintroduce per-field renaming here.
// // ---------------------------------------------------------------------------

// const isDateKey = (key) =>
//   key.includes("_date_") ||
//   key.endsWith("_date") ||
//   key.includes("_planned") ||
//   key.includes("_actual");

// /**
//  * Flattens tracking.section1..sectionN (arrays of small objects) into one
//  * flat { [apiKey]: value } object, ready to hand to Form.setFieldsValue.
//  * Date-like values are converted to dayjs so DatePicker can render them.
//  *
//  * NOTE: a handful of fields in the API (e.g. a bare "remarks" key) are
//  * genuinely reused across more than one item in the same section. When that
//  * happens the last occurrence wins here - this mirrors how the backend
//  * already collapses them, it's not something the frontend can disambiguate.
//  */
// export const flattenTracking = (tracking) => {
//   const values = {};
//   if (!tracking) return values;

//   Object.keys(tracking)
//     .filter((key) => /^section\d+$/.test(key))
//     .forEach((sectionKey) => {
//       const section = tracking[sectionKey];
//       if (!Array.isArray(section)) return;

//       section.forEach((item) => {
//         Object.entries(item).forEach(([key, value]) => {
//           values[key] = isDateKey(key) && value ? dayjs(value) : value;
//         });
//       });
//     });

//   return values;
// };

// /**
//  * Converts a flat form-values object into a PATCH-ready payload:
//  * - dayjs -> "YYYY-MM-DD" string
//  * - drops undefined / null / "" so we never accidentally blank out a field
//  *   that simply wasn't part of the currently-mounted tab
//  */
// export const cleanTrackingPayload = (data) => {
//   const cleaned = {};

//   Object.entries(data).forEach(([key, value]) => {
//     if (dayjs.isDayjs(value)) {
//       cleaned[key] = value.isValid() ? value.format("YYYY-MM-DD") : null;
//     } else if (value !== undefined && value !== null && value !== "") {
//       cleaned[key] = value;
//     }
//   });

//   return cleaned;
// };
import dayjs from "dayjs";

// ---------------------------------------------------------------------------
// GOLDEN RULE: the Form.Item `name` used in every *LandForm.js component must
// be IDENTICAL to the key the API returns inside section1..sectionN arrays.
// ---------------------------------------------------------------------------

const isDateKey = (key) => {
  return (
    key.endsWith("_date") ||
    key.endsWith("_date_actual") ||
    key.endsWith("_date_planned") ||
    key.endsWith("_date_expected")
  );
};

/**
 * Flattens tracking.section1..sectionN (arrays of small objects) into one
 * flat object ready for Form.setFieldsValue().
 *
 * Date fields are converted to dayjs objects so Ant Design DatePicker works.
 */
export const flattenTracking = (tracking) => {
  const values = {};

  if (!tracking) return values;

  Object.keys(tracking)
    .filter((key) => /^section\d+$/.test(key))
    .forEach((sectionKey) => {
      const section = tracking[sectionKey];

      if (!Array.isArray(section)) return;

      section.forEach((item) => {
        Object.entries(item).forEach(([key, value]) => {
          if (isDateKey(key) && value) {
            values[key] = dayjs(value);
          } else {
            values[key] = value;
          }
        });
      });
    });

  return values;
};

/**
 * Converts form values into a PATCH-ready payload.
 *
 * - dayjs -> YYYY-MM-DD
 * - removes undefined/null/empty string
 */
export const cleanTrackingPayload = (data) => {
  const cleaned = {};

  Object.entries(data).forEach(([key, value]) => {
    if (dayjs.isDayjs(value)) {
      if (value.isValid()) {
        cleaned[key] = value.format("YYYY-MM-DD");
      }
    } else if (value !== undefined && value !== null && value !== "") {
      cleaned[key] = value;
    }
  });

  return cleaned;
};  